import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LANG, SUPPORTED_LANGS, type Lang } from '@/i18n/config';
import { localizePath } from '@/i18n/paths';

/** Current UI language, narrowed to a supported code. */
export function useLang(): Lang {
  const { i18n } = useTranslation();
  return (SUPPORTED_LANGS as readonly string[]).includes(i18n.language)
    ? (i18n.language as Lang)
    : DEFAULT_LANG;
}

/**
 * `const lp = useLocalizedPath(); <Link to={lp('/guide')} />`
 *
 * Returns the path prefixed for the active language when it belongs to a
 * language-prefixed route family, otherwise unchanged.  See `i18n/paths.ts`.
 */
export function useLocalizedPath(): (target: string) => string {
  const lang = useLang();
  return useCallback((target: string) => localizePath(target, lang), [lang]);
}
